import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { login } = useAuth();
  const [error, setError] = useState<string | null>(null);


  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);
    
    try {
      await login({ email, password });
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Login failed';
      setError(message);
      window.alert('Wrong login details provided.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-primary-800 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full">
        <div className="rounded-sm border-t-4 border-accent-500 bg-white p-8 shadow-pop">
          {/* This screen is shared across every municipality tenant — before
              sign-in, there is no session to resolve a specific tenant's own
              logo/name from, so it deliberately shows generic platform
              branding rather than any one municipality's crest. Each
              municipality's own name/logo appears everywhere after sign-in
              (see Layout.tsx), which reads it from the logged-in user's own
              tenant record. */}
          <div className="text-center">
            <h2 className="text-2xl font-bold text-primary-900">
              Municipal Service Delivery Portal
            </h2>
            <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">
              Admin Portal Login
            </p>
          </div>

          <form className="mt-8 space-y-4" onSubmit={handleSubmit}>
            <div>
              <label htmlFor="email" className="sr-only">
                Email address
              </label>
              <input
                id="email"
                name="email"
                type="email"
                autoComplete="email"
                required
                className="block w-full rounded-sm border border-gray-300 px-3 py-2 text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500 sm:text-sm"
                placeholder="Email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div>
              <label htmlFor="password" className="sr-only">
                Password
              </label>
              <input
                id="password"
                name="password"
                type="password"
                autoComplete="current-password"
                required
                className="block w-full rounded-sm border border-gray-300 px-3 py-2 text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500 sm:text-sm"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>

            {error && (
              <div className="text-red-600 text-sm text-center">{error}</div>
            )}

            <div>
              <button
                type="submit"
                disabled={isLoading}
                className="group relative w-full flex justify-center py-2 px-4 border border-primary-700 text-sm font-medium rounded-sm text-white bg-primary-700 hover:bg-primary-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {isLoading ? 'Signing in...' : 'Sign in'}
              </button>
            </div>
            <div className="text-center text-sm text-gray-600 dark:text-gray-400">
              Need to register a municipality?{' '}
              <a href="/register" className="text-primary-700 hover:text-primary-800 font-medium">
                Create an admin account
              </a>
            </div>
            <div className="text-center text-sm text-gray-600 dark:text-gray-400">
              Looking for your municipality's public status page?{' '}
              <Link to="/find-municipality" className="text-primary-700 hover:text-primary-800 font-medium">
                Find your municipality
              </Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;

